import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-size: 1080px;
  height: 960px;
  background: linear-gradient(
    180deg,
    rgba(119, 80, 233, 0) 0%,
    rgba(119, 80, 233, 0.2) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 475px) {
    height: 650px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 0;
  padding: 24px 25px;
  align-items: center;
`;

export const HeaderText = styled.div`
  display: flex;
  gap: 16px;
`;

export const LandingTop = styled.div`
  width: 100%;
  max-width: 1080px;
  display: flex;
  flex-direction: column;
`;

export const TextGradation = styled.p`
  background: linear-gradient(90deg, #9170f2 30.42%, #d3c5fd 69.86%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  font-size: 32px;
  font-weight: 800;
  margin-top: 100px;
  @media (max-width: 475px) {
    font-size: 1.8rem; /* 화면이 475px 이하일 때 폰트 크기 변경 */
  }
`;

export const LandingTopText = styled.p`
  text-align: center;
  font-size: 56px;
  font-weight: 800;
  white-space: pre-line;
  line-height: 72px;
  @media (max-width: 475px) {
    font-size: 32px; /* 화면이 475px 이하일 때 폰트 크기 변경 */
    line-height: 48px; /* 필요 시 줄 간격도 함께 조정 */
  }
`;
